/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled, { css } from 'styled-components'
import { Subject } from 'interfaces/Subject'
import { colorToCssFilter } from 'lib/features/color'
import CardContainer from '../../elements/CardContainer'
import { Body2, Headline4 } from '../../../stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import { formatSubjectLabel, getSubjectColorByCategory } from 'lib/formatting/subjects'

interface Props {
    subject: Subject
    isSelected?: boolean
    to?: string
    showTitleAsSubHeadline?: boolean
    isDarkTheme?: boolean
}

const Container = styled.div<{ readonly borderColor: string | null; readonly shouldHover?: boolean; isDarkTheme?: boolean }>`
    cursor: pointer;

    border-radius: ${theme.borderRadius.normal};
    border: 1px solid ${theme.colors.primaryGray};

    ${({ borderColor }) =>
        borderColor
            ? css`
                  border-color: ${borderColor};
              `
            : ''}

    &:hover {
        box-shadow: ${(props) => (props.shouldHover ? '0px 0px 15px rgba(0, 0, 0, 0.05);' : '0;')};
    }
`

const Element = styled.div<{
    readonly iconColorFilter: string
}>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    gap: 10px;
    height: 85px;
    cursor: pointer;
    p {
        word-break: break-all;
    }
    & .icon {
        filter: ${(props) => props.iconColorFilter};
    }
`

const SubjectBody = (props: Props) => {
    const md = useMedia(deviceSize.md)
    const iconColorFilter = colorToCssFilter(getSubjectColorByCategory(props.subject.colorCategory))

    const Title = props.showTitleAsSubHeadline ? Headline4 : Body2

    return (
        <Container
            borderColor={
                props.isDarkTheme
                    ? theme.colors.backgroundTransparent
                    : props.isSelected
                    ? getSubjectColorByCategory(props.subject.colorCategory)
                    : null
            }
            shouldHover
            key={props.subject.id}
            isDarkTheme={props.isDarkTheme}
        >
            <CardContainer
                height={75}
                borderColor={props.isDarkTheme ? theme.colors.grayScalePrimary : theme.colors.lightBorder}
                backgroundColor={props.isDarkTheme ? theme.colors.transparent : undefined}
            >
                <Element iconColorFilter={iconColorFilter}>
                    <div className="icon">
                        <img src={props.subject.iconUrl} alt={props.subject.name} width={25} height={25} />
                    </div>

                    <Title
                        color={props.isDarkTheme ? theme.colors.white : theme.colors.placeholderText}
                        fontFamily="var(--font-inter)"
                        fontWeight={400}
                        fontSize={md ? 12 : 13}
                    >
                        {formatSubjectLabel(props.subject)}
                    </Title>
                </Element>
            </CardContainer>
        </Container>
    )
}

export default SubjectBody
